// workflow version 1 and 2

// register for event divisions
export const legacyMemberRegistrationCheckout = (axiosInstance, eventId, data) => {
    return axiosInstance.post(`/v2/tms/events/${eventId}/register`, data);
};

// update registration (add/remove/swap reg divisions)
export const legacySwitchDivisions = (axiosInstance, eventId, payload) => {
    return axiosInstance.put(`/v2/tms/events/${eventId}/registrations/update`, payload);
};

export const legacyMultiRegistration = (axiosInstance, eventId, payload) => {
    return axiosInstance.post(`/v1/tms/camps/${eventId}/register`, payload);
};

// decline player invites to an event
export const legacyRemovePartners = (axiosInstance, eventId, divisions) => {
    return axiosInstance.post(`/v2/tms/events/${eventId}/registrations/remove-partners`, { divisions });
};

// TBD should be okay to WV3+
export const declineAdminAddedDivisions = (axiosInstance, eventId, divisions) => {
    return axiosInstance.post(`/v2/tms/events/${eventId}/registrations/decline-admin-add`, { divisions });
};

// TBD probably needs legacy prefix, we'll see
export const withdrawPlayerFromEvent = (axiosInstance, eventId, data) => {
    return axiosInstance.post(`/v1/tms/events/${eventId}/withdraw`, data);
};

// TBD probably needs legacy prefix, we'll see
export const partialWithdrawPlayerFromEvent = (axiosInstance, eventId, data) => {
    return axiosInstance.post(`/v1/tms/events/${eventId}/partial-withdraw`, data);
};

// TBD this may end up as a direct route to payments API
export const legacyCheckRegistration = (axiosInstance, eventId, checkoutId) => {
    return axiosInstance.get(`/v1/tms/events/${eventId}/register?checkoutId=${checkoutId}`);
};

export const validatePromoCode = (axiosInstance, couponValidationRequest) => {
    return axiosInstance.post('v1/promotion/discount/validate', couponValidationRequest);
};

export const getPromoCodeRefundData = (axiosInstance, eventId, promoCodeRefundRequest) => {
    return axiosInstance.post(`v2/tms/events/${eventId}/registrations/calculate-refund`, promoCodeRefundRequest);
};

export const getSelfWithdrawRefundData = (axiosInstance, eventId, promoCodeRefundRequest) => {
    return axiosInstance.post(`v2/tms/events/${eventId}/self-withdraw/calculate-refund`, promoCodeRefundRequest);
};

// workflow version 3

// new registration.
// must carry payment method ID from stripe (or other payment provider info)
export const createMemberRegistration = (axiosInstance, eventId, data) => {
    return axiosInstance.post(`/v3/tms/events/${eventId}/register-divisions`, data);
};

// update existing registration (switch divisions).
// may carry payment method ID from stripe (or other payment provider info) if
// the update would result in additional charges
export const updateMemberRegistration = (axiosInstance, eventId, data) => {
    return axiosInstance.put(`/v3/tms/events/${eventId}/register-divisions`, data);
};

// TBD current member's registration state
export const getMemberRegistration = (axiosInstance, eventId) => {
    return axiosInstance.get(`/v3/tms/events/${eventId}/register-divisions`);
};

// TBD new UX will poll this route until the customer leaves the page
export const getMemberRegistrationCheckoutStatus = (axiosInstance, eventId, checkoutId) => {
    return axiosInstance.get(`/v3/tms/events/${eventId}/register-divisions/${checkoutId}`);
};
